export default __webpack_public_path__ + "static/media/Popup.60fa1061.png";